import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, TestGorgiasIntegrationResponseDataSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.input<typeof TestGorgiasIntegrationResponseDataSchema>>

export function useTestGorgiasTicketMutation() {
  return useMutation({
    mutationFn: async (data: z.input<typeof TestGorgiasIntegrationResponseDataSchema>) => {
      const response = await axios.post<Response>(`/integrations/gorgias/test`, data)

      return response.data.data
    },
  })
}
